import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef} from "ag-grid-community";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";
import AGGridEmailRenderer from "@/components/inputs/AGGridEmailRenderer.vue";

export default class AGGridEmailColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = AGGridEmailRenderer;
    return colDef;
  }
}
